import authService, { USER_ROLES } from '@/api/authService'
import i18n from '@/i18n'

const allOption = () => ({ id: 'all', label: i18n.t('ALL_ZIPCODES'), name: i18n.t('ALL_ZIPCODES'), code: i18n.t('ALL_ZIPCODES') })

export default {
  name: 'ZipcodeSelector',
  mixins: [],
  components: {
    ZipcodeGroupSelector: () => import(/* webpackChunkName: "ZipcodeGroupSelector" */ '@/components/zipcode-group-selector/ZipcodeGroupSelector.vue')
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: Array,
      required: true
    },
    meta: {
      type: Object,
      required: true,
      default: () => ({ loading: false, count: 0 })
    },
    showFootnote: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      authData: authService.authData
    }
  },
  computed: {
    isExplore () {
      return this.$route.name === 'explore'
    },
    isDirector () {
      return this.authData.user.role === USER_ROLES.DIRECTOR
    },
    selectedCount () {
      const allSelected = this.selected.length === 1 && this.selected[0].id === 'all'
      return allSelected ? this.meta.count : this.selected.length
    }
  },
  methods: {
    zoneIsSelected (opt) {
      return this.selected.some(z => z.id === opt.id)
    },
    onZoneSelected (zone) {
      let newZones
      if (this.zoneIsSelected(zone)) {
        newZones = this.selected.filter(z => z.id !== zone.id)
      } else {
        if (zone.id === 'all') {
          newZones = [zone]
        } else {
          newZones = this.selected.filter(z => z.id !== 'all').concat(zone)
        }
      }
      this.emitChange(newZones)
    },
    onZoneGroupSelected (group) {
      this.$emit('zoneGroupSelected', group)
    },
    clearZones () {
      this.emitChange([])
    },
    emitChange (zones) {
      this.$emit('zonesSelected', zones)
    },
    selectAll () {
      this.onZoneSelected(allOption())
    }
  }
}
